import { useState } from 'react';

import { Link } from 'react-router';

import { type Breadcrumb, BreadcrumbSchema } from '@boc/framework';

import { cn } from '~/styling';
import { absoluteify } from '~/urls';

export const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => {
  const [highlightedIndex, setHighlightedIndex] = useState<number | null>(null);

  return (
    <>
      <BreadcrumbSchema
        breadcrumbs={breadcrumbs.map((breadcrumb) => ({
          ...breadcrumb,
          url: absoluteify(breadcrumb.url),
        }))}
      />
      <div className="font-heading flex items-center gap-2 overflow-x-auto py-4 text-xs leading-3 font-medium tracking-wide capitalize">
        {breadcrumbs.map((breadcrumb, index) => (
          <div key={breadcrumb.name} className="flex items-center gap-2 whitespace-nowrap">
            {index < breadcrumbs.length - 1 ? (
              <>
                <Link
                  to={breadcrumb.url}
                  onMouseEnter={() => setHighlightedIndex(index)}
                  onMouseLeave={() => setHighlightedIndex(null)}
                  className={cn(
                    'relative after:absolute after:bottom-[-2px] after:left-0 after:h-[1px] after:w-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full',
                    highlightedIndex === index ? 'after:w-full' : '',
                    'transition-colors duration-150'
                  )}
                >
                  {breadcrumb.name}
                </Link>
                <span>&gt;</span>
              </>
            ) : (
              <span
                className={cn(
                  'relative after:absolute after:bottom-[-2px] after:left-0 after:h-[1px] after:bg-current after:transition-all after:duration-300 after:ease-in-out',
                  !highlightedIndex ? 'after:w-full' : 'after:w-0',
                  'transition-colors duration-150'
                )}
              >
                {breadcrumb.name}
              </span>
            )}
          </div>
        ))}
      </div>
    </>
  );
};
